// Client-details.js
const Clientlogo = [
    {
      id: 1,
      images: '/client1.jpg', 
    },
    {
        id: 2,
        images: '/client2.jpg', 
      },
      {
        id: 3,
        images: '/client3.jpg', 
      },
      {
        id: 4,
        images: '/client4.jpg', 
      },
      {
        id: 5,
        images: '/client5.jpg', 
      },
      {
        id: 6,
        images: '/client6.jpg', 
      },
      {
        id: 7,
        images: '/client7.jpg', 
      },
      {
        id: 8,
        images: '/client8.jpg', 
      },
      {
        id: 9,
        images: '/client9.jpg', 
      },
      {
        id: 10,
        images: '/client10.jpg', 
      },
      {
        id: 11,
        images: '/client11.jpg', 
      },
      {
        id: 12,
        images: '/client12.jpg', 
      },
      {
        id: 13,
        images: '/client13.jpg', 
      },
      
  ];
export default Clientlogo;  